import { useEffect, useState } from "react";
import { api, puede } from "../api.ts";
import { leerCache, guardarCache } from "../cache.ts";
import { DIAS_PLAZO_FICHA_INCOMPLETA, DIAS_AVISO_FICHA_INCOMPLETA } from "../../../dominio/src/index.ts";

interface Ficha { id: string; hc: number; nombre: string; telefono: string; dias: number; limite: string; restan: number; avisar: boolean; vencida: boolean }

/**
 * Tarjeta de Inicio con los pacientes que se registraron «al paso» (solo nombres y celular) y todavía no tienen cédula o pasaporte.
 * Aparece desde que hay uno; a los 7 días se marca en rojo y a los 30 días Donna ya no deja registrar nada clínico hasta completar la ficha.
 */
export function FichasPorCompletar({ ir }: { ir: (ruta: string) => void }) {
  const [lista, setLista] = useState<Ficha[] | null>(() => leerCache<Ficha[]>("inicio.fichas") ?? null);
  useEffect(() => { if (puede("pacientes:leer")) api<Ficha[]>("GET", "/api/fichas-por-completar").then((r) => setLista(guardarCache("inicio.fichas", r))).catch(() => undefined); }, []);
  if (!lista || !lista.length) return null;
  const vencidas = lista.filter((f) => f.vencida).length, porVencer = lista.filter((f) => f.avisar && !f.vencida).length;
  return (
    <section className="card" aria-labelledby="t-fichas">
      <div className="fila" style={{ justifyContent: "space-between", alignItems: "baseline", flexWrap: "wrap", gap: 8 }}>
        <h2 id="t-fichas" style={{ margin: 0 }}>Fichas por completar</h2>
        {vencidas > 0 ? <span className="chip rojo">{vencidas} sin poder registrar lo clínico</span> : porVencer > 0 ? <span className="chip rojo">{porVencer} por vencer</span> : <span className="chip">{lista.length}</span>}
      </div>
      <p className="muted" style={{ margin: 0, fontSize: 13 }}>
        Pacientes registrados solo con nombres y celular. La historia clínica única exige su <b>cédula o pasaporte</b> y fecha de nacimiento: a los {DIAS_AVISO_FICHA_INCOMPLETA} días se marca en rojo y a los {DIAS_PLAZO_FICHA_INCOMPLETA} días ya no se puede registrar nada clínico hasta completar la ficha.
      </p>
      <ul className="lista-abonos">
        {lista.slice(0, 8).map((f) => (
          <li key={f.id} className="cumple">
            <div className="fila" style={{ justifyContent: "space-between", alignItems: "baseline", flexWrap: "wrap" }}>
              <span><button className="enlace" onClick={() => ir(`paciente/${f.id}`)}><b>{f.nombre}</b></button> <span className="muted mono">HC {f.hc}</span></span>
              <span className={`chip${f.avisar ? " rojo" : ""}`}>{f.vencida ? `Plazo vencido hace ${-f.restan} día${f.restan === -1 ? "" : "s"}`.replace("hace 0 días", "hoy") : `Quedan ${f.restan} día${f.restan === 1 ? "" : "s"}`}</span>
            </div>
          </li>
        ))}
      </ul>
      {lista.length > 8 && <p className="muted" style={{ margin: 0, fontSize: 13 }}>…y {lista.length - 8} más.</p>}
    </section>
  );
}
